import doc                  from 'decorators/doc';
import model                from 'decorators/model';
import SalesPrivateApiModel from '../../abstracts/SalesPrivateApiModel';

@model.cacheDuration(3600)
@model.staticLabel('Statut')
@model.urnResource('contract_status')
@doc.path('/contract_statuses/{?id}')
export default class ContractStatusModel extends SalesPrivateApiModel {
	public _filters: ModelFiltersExtended<{
		'reference': SalesContractStatusReference;
	}> = {};

	public _sorts: ModelSortsExtended<unknown> = {};

	@doc.string declare label: string;
	@doc.string declare reference: SalesContractStatusReference;

	public get color() {
		switch (this.reference) {
			case 'CONTRACT_STATUS_SUSPENDED':
				return '#ff0000';
			case 'CONTRACT_STATUS_BEING_PREPARED':
				return '#000080';
			case 'CONTRACT_STATUS_ON_GOING':
				return '#008000';
			default:
				return '#808080';
		}
	}
}